import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Emits FAQPage JSON-LD only — renders nothing visible. Feed it the page's
 * existing on-screen FAQ array so the structured data matches what users see
 * (a Google requirement for valid FAQPage markup). Helps AI search / GEO and
 * long-tail question queries.
 *
 * Props: faqs - array of { q, a }
 */
export default function FaqSchema({ faqs = [] }) {
  if (!faqs.length) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
